import { CreatePlayerRequest } from '../models/player';

class PlayerService {
    public async createPlayer(name: string) {
        try {
            const request: CreatePlayerRequest = {
                name,
            };
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/players`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            });
            return {
                body: await response.json(),
                status: response.status,
            };
        } catch (error) {
            console.error('Error creating player:', error);
            throw error;
        }
    }
}

export const playerService = new PlayerService();